import { BreakpointWidth } from '@core/styles/breakpoints';

type AnalyticsDeviceCategory = 'Desktop' | 'Tablet' | 'Handset';

export const toDeviceCategoryFromWindow = (
  width = window.innerWidth,
): AnalyticsDeviceCategory => {
  if (width >= BreakpointWidth.desktop) {
    return 'Desktop';
  } else if (width >= BreakpointWidth.tablet) {
    return 'Tablet';
  } else {
    return 'Handset';
  }
};
